var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 630 153",
    fill: "none",
    className: "logo_svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.65 97.93C23.3 121.23 35.07 134.42 54.6 134.42C68.02 134.42 76.96 128.06 82.14 114.65H102.86C97.45 138.42 79.32 152.55 54.13 152.55C22.13 152.55 0 128.06 0 92.52C0 56.98 21.65 32.73 53.43 32.73C76.03 32.73 92.5 44.73 100.04 66.62C102.87 75.09 104.28 84.27 104.51 97.93H21.65ZM81.91 82.16C80.97 61.45 70.61 49.91 53.43 49.91C36.25 49.91 23.06 63.09 21.89 82.16H81.91Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.95 74.3902C194.65 58.8602 184.77 50.8502 169.23 50.8502C148.51 50.8502 134.63 67.3302 134.63 92.2802C134.63 117.23 148.28 134.41 169.23 134.41C186.18 134.41 196.3 125.23 199.36 106.87H219.84C216.78 135.82 198.18 152.54 168.76 152.54C134.86 152.54 112.74 128.76 112.74 92.5102C112.74 56.2602 135.1 32.7202 169.47 32.7202C197.24 32.7202 215.37 48.0202 218.43 74.3802H197.95V74.3902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.4 93.4602C335.4 128.3 313.04 152.54 280.56 152.54C248.08 152.54 225.95 128.29 225.95 92.5102C225.95 56.7302 248.08 32.7202 280.56 32.7202C313.04 32.7202 335.4 56.7302 335.4 93.4502V93.4602ZM247.84 92.5202C247.84 119.12 259.84 134.42 280.79 134.42C301.74 134.42 313.51 119.12 313.51 93.2302C313.51 65.9302 301.74 50.8602 280.56 50.8602C259.38 50.8602 247.84 66.1602 247.84 92.5202Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.99 35.7902V53.6802C374.46 47.0902 376.35 44.5002 379.4 41.6802C384.58 36.2702 392.82 32.7402 399.65 32.7402C403.89 32.7402 407.89 33.6802 411.65 35.5602V55.1002C407.18 54.1602 404.82 53.9202 401.76 53.9202C384.34 53.9202 370.92 69.4602 370.92 89.7002V149.49H349.26V35.7902H369.98H369.99Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.86 74.3902C493.56 58.8602 483.68 50.8502 468.14 50.8502C447.42 50.8502 433.54 67.3302 433.54 92.2802C433.54 117.23 447.19 134.41 468.14 134.41C485.09 134.41 495.21 125.23 498.27 106.87H518.75C515.69 135.82 497.09 152.54 467.67 152.54C433.77 152.54 411.65 128.76 411.65 92.5102C411.65 56.2602 434.01 32.7202 468.38 32.7202C496.15 32.7202 514.28 48.0202 517.34 74.3802H496.86V74.3902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.51 97.93C548.16 121.23 559.93 134.42 579.46 134.42C592.88 134.42 601.82 128.06 607 114.65H627.72C622.31 138.42 604.18 152.55 578.99 152.55C546.98 152.55 524.85 128.07 524.85 92.52C524.85 56.97 546.5 32.73 578.28 32.73C600.88 32.73 617.35 44.73 624.89 66.62C627.72 75.09 629.13 84.27 629.36 97.93H546.5H546.51ZM606.77 82.16C605.83 61.45 595.47 49.91 578.29 49.91C561.11 49.91 547.92 63.09 546.75 82.16H606.77Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.78 0H18.61V14.22H606.78V0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 629.37,
    height: 152.55,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bcbf224960ce345e992bb7c742bbc7a1.svg";
export { ForwardRef as ReactComponent };